var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-left": "15px" } },
    [
      _c("div", { staticStyle: { display: "none" } }, [
        _vm._v(_vm._s(_vm.counter)),
      ]),
      _vm._v(" "),
      _vm._l(_vm.treeArray, function (node, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("div", { staticClass: "tree-content" }, [
              _c("i", {
                class: {
                  "tree-arrow": true,
                  "has-child": node.count_children != 0,
                  loading: !node.expand ? node.loading : false,
                  expand: node.expand,
                },
                on: {
                  click: function () {
                    return _vm.expand(node)
                  },
                },
              }),
              _vm._v(" "),
              _c("i", {
                class: {
                  "tree-checkbox": true,
                  checked: node.checked,
                  indeterminate: !node.checked
                    ? _vm.isAnyoneChecked(node)
                    : false,
                },
                on: {
                  click: function () {
                    return _vm.check(node)
                  },
                },
              }),
              _vm._v(" "),
              _vm.registry == "okved"
                ? _c("span", { staticClass: "tree-anchor" }, [
                    _vm._v(
                      _vm._s(node.code.replace("2014:", "")) +
                        " - " +
                        _vm._s(node.title)
                    ),
                  ])
                : _vm.registry == "fias"
                ? _c("span", { staticClass: "tree-anchor" }, [
                    _vm._v(_vm._s(node.title)),
                  ])
                : _c("span", { staticClass: "tree-anchor" }, [
                    _vm._v(_vm._s(node.code) + " - " + _vm._s(node.title)),
                  ]),
            ]),
            _vm._v(" "),
            node.expand
              ? _c("tree", {
                  attrs: { treeArray: node.children, registry: _vm.registry },
                })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }